import { render } from "./vehicleChoose.vue?vue&type=template&id=3771bd27&scoped=true"
import script from "./vehicleChoose.vue?vue&type=script&lang=js"
export * from "./vehicleChoose.vue?vue&type=script&lang=js"

import "./vehicleChoose.vue?vue&type=style&index=0&id=3771bd27&lang=less&scoped=scoped"

import exportComponent from "/data/spug/spug_api/repos/34_1470_20220520214630/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3771bd27"]])

export default __exports__